import { useNavigate } from "react-router-dom";
import BrandMarks from "./BrandMarks";

export default function Footer() {
  const navigate = useNavigate();
  const go = path => { navigate(path); window.scrollTo({ top: 0, behavior: "smooth" }); };

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-brand-marks">
            <BrandMarks size={40}/>
          </div>
          <div className="fb1">Korea Papua LNG</div>
          <div className="fb2">
            Connecting Korean contractors, workers and companies with the
            Papua LNG Project — established by a group of Koreans and
            Papua LNG landowners.
          </div>
        </div>

        <div className="footer-col">
          <h4>Navigation</h4>
          {[
            ["/",               "Home"],
            ["/about",           "About the Project"],
            ["/working-in-png",  "Working in PNG"],
            ["/opportunities",   "Business Opportunities"],
            ["/apply",           "Apply / Register"],
          ].map(([path, label]) => (
            <button key={path} className="f-lnk" onClick={() => go(path)}>{label}</button>
          ))}
        </div>

        <div className="footer-col">
          <h4>For Korean Workers</h4>
          {[
            ["/apply/visa", "Employment Visa Request"],
            ["/apply/jobs", "Job Seeker Registration"],
          ].map(([path, label]) => (
            <button key={path} className="f-lnk" onClick={() => go(path)}>{label}</button>
          ))}
        </div>

        <div className="footer-col">
          <h4>For Korean Companies</h4>
          {[
            ["/apply/company", "Subcontract Submission"],
            ["/apply/general", "General Business Interest"],
          ].map(([path, label]) => (
            <button key={path} className="f-lnk" onClick={() => go(path)}>{label}</button>
          ))}
        </div>

      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Korea Papua LNG. Independent portal serving the Papua LNG Project's Korean workforce and business community.</span>
        <span>Papua New Guinea · Republic of Korea</span>
      </div>
    </footer>
  );
}
